import throttle from "lodash.throttle";
document.documentElement.classList.remove("no-js");

/**
 * title Lazy Load
 * description Lazy Loading Images
 **/
import { lazy } from "./modules/lazy-load";

if (document.readyState !== "loading") {
	lazy();
}

/**
 * title Tab Navigation
 **/
import { tabNavigation } from "./modules/tabs";

/**
 * title: Cookies
 **/
import { initiateCookies } from "./modules/cookie-notice.js";

if (document.getElementById("cookie-notice")) {
	initiateCookies();
}

/**
 * @title Tracking Scripts
 * @description Initialise the logic for handling SEOMatic Tracking Scripts with Blitz
 **/

import { initialiseTrackingScripts } from "./molecules/seo-tracking.js";
initialiseTrackingScripts();

/**
 * title: Announcement Banner
 **/
import "./modules/announcement-banner";

/**
 * title: Mobile Menu
 **/
// import "./molecules/mobile-menu";

/**
 * title: Desktop Menu
 **/
import { initMenu } from "./molecules/menu";

/**
 * title: Menu Resize
 **/
import { menuResize } from "./molecules/menu-resize";

/**
 * title: Accordions
 **/
import { accordion } from "./molecules/accordion";

/**
 * title: Content Table
 **/
import { contentTable, tableScroll } from "./molecules/content-table";

/**
 * title: Lottie Animation
 **/
import { loadLottie } from "./molecules/lottie-animation";

// Load all JS after Content Load
document.addEventListener("DOMContentLoaded", function () {
	lazy();
	initMenu();
	tabNavigation();
	menuResize();
	contentTable();
	tableScroll();
	accordion();
	loadLottie();
});

// Fire on Resize
window.addEventListener("resize", throttle(menuResize, 50), false);
window.addEventListener("scroll", throttle(contentTable, 100), false);
